import React, { useState, useEffect, useCallback } from 'react';
import empresaService from '../../services/empresa.service';
import BtnIcone from '../../components/BtnIcone';
import SePode from '../../components/SePode';   // r88: botões condicionais por permissão
import Modal from '../../components/Modal';
import GridValores from '../../components/GridValores';
import BrowseHeader from '../../components/BrowseHeader';                    // r109
import { iconeDaRotina } from '../../constants/iconesRotinas';               // r109

const COR = {
  azul:     '#003399',
  azulBg:   '#eff6ff',
  borda:    '#e8eaed',
  texto:    '#1a1a2e',
  muted:    '#888',
  branco:   '#fff',
  verde:    '#1D9E75',
  verdeBg:  '#f0fff4',
  vermelho: '#e53935',
  vermBg:   '#fff0f0',
  amarelo:  '#d97706',
  amlBg:    '#fffbeb',
  cinzaBg:  '#fafbfc',
};

const inputStyle = {
  width: '100%', height: '36px', padding: '0 10px',
  border: `1px solid ${COR.borda}`, borderRadius: '5px',
  fontSize: '13px', boxSizing: 'border-box',
  backgroundColor: COR.branco, color: COR.texto, outline: 'none',
  // r136: fonte Manrope nos selects também (padrão Colaborador)
  fontFamily: "'Manrope', sans-serif",
};

const selectStyle = { ...inputStyle, cursor: 'pointer' };

const textareaStyle = {
  width: '100%', padding: '8px 10px',
  border: `1px solid ${COR.borda}`, borderRadius: '5px',
  fontSize: '13px', boxSizing: 'border-box',
  backgroundColor: COR.branco, color: COR.texto,
  outline: 'none', resize: 'vertical', minHeight: '80px',
  fontFamily: "'Manrope', sans-serif",
};

const UFS = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG',
             'PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

// ─── Formata CNPJ: 00.000.000/0000-00 ────────────────────────────────────────
function formatarCnpj(cnpj) {
  const n = (cnpj || '').replace(/\D/g, '');
  if (n.length !== 14) return cnpj;
  return `${n.slice(0,2)}.${n.slice(2,5)}.${n.slice(5,8)}/${n.slice(8,12)}-${n.slice(12)}`;
}

// Máscara visual dinâmica pra input
function mascararCnpj(valor) {
  const nums = valor.replace(/\D/g, '').slice(0, 14);
  if (nums.length <= 2)  return nums;
  if (nums.length <= 5)  return `${nums.slice(0,2)}.${nums.slice(2)}`;
  if (nums.length <= 8)  return `${nums.slice(0,2)}.${nums.slice(2,5)}.${nums.slice(5)}`;
  if (nums.length <= 12) return `${nums.slice(0,2)}.${nums.slice(2,5)}.${nums.slice(5,8)}/${nums.slice(8)}`;
  return `${nums.slice(0,2)}.${nums.slice(2,5)}.${nums.slice(5,8)}/${nums.slice(8,12)}-${nums.slice(12)}`;
}

// r136: máscara CEP: 00000-000 (8 dígitos)
function mascararCep(valor) {
  const nums = String(valor || '').replace(/\D/g, '').slice(0, 8);
  if (nums.length <= 5) return nums;
  return `${nums.slice(0, 5)}-${nums.slice(5)}`;
}
function limparCep(valor) {
  return String(valor || '').replace(/\D/g, '').slice(0, 8);
}

// ─── r136: SVGs (ícones das seções + chevron) ─────────────────────────────────
// Mesmo padrão Colaborador.
const SvgEmpresa = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
    <line x1="9" y1="7" x2="9" y2="7"/>
    <line x1="9" y1="11" x2="9" y2="11"/>
    <line x1="9" y1="15" x2="9" y2="15"/>
    <line x1="15" y1="7" x2="15" y2="7"/>
    <line x1="15" y1="11" x2="15" y2="11"/>
    <line x1="15" y1="15" x2="15" y2="15"/>
  </svg>
);
const SvgEndereco = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);
const SvgFinanceiro = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="1" x2="12" y2="23"/>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
  </svg>
);
const SvgValores = ({ size = 18, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/>
    <line x1="12" y1="6" x2="12" y2="18"/>
  </svg>
);
const SvgChevron = ({ size = 14, color = 'currentColor', aberto }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color}
       strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
       style={{
         transform: aberto ? 'rotate(180deg)' : 'rotate(0deg)',
         transition: 'transform 0.15s',
       }}>
    <polyline points="6 9 12 15 18 9"/>
  </svg>
);

// ─── r136: Seção expansível (padrão Colaborador) ─────────────────────────────
function Secao({ icone: Icone, titulo, aberta, onToggle, children, fixa }) {
  const estaAberta = fixa ? true : aberta;
  return (
    <div style={{
      border: `1px solid ${COR.borda}`, borderRadius: '6px',
      marginBottom: '12px', overflow: 'hidden', backgroundColor: COR.branco,
    }}>
      <div
        onClick={fixa ? undefined : onToggle}
        style={{
          padding: '12px 16px',
          backgroundColor: estaAberta ? COR.azulBg : COR.cinzaBg,
          borderBottom: estaAberta ? `1px solid ${COR.borda}` : 'none',
          cursor: fixa ? 'default' : 'pointer',
          userSelect: 'none',
          display: 'flex', alignItems: 'center', gap: '10px',
          transition: 'background-color 0.15s',
        }}
      >
        {Icone && (
          <span style={{ display: 'inline-flex', color: estaAberta ? COR.azul : COR.muted }}>
            <Icone size={18} />
          </span>
        )}
        <span style={{
          flex: 1, fontSize: '14px', fontWeight: '700',
          color: estaAberta ? COR.azul : COR.texto,
        }}>
          {titulo}
        </span>
        {!fixa && (
          <span style={{ display: 'inline-flex', color: COR.muted }}>
            <SvgChevron aberto={estaAberta} size={16} />
          </span>
        )}
      </div>
      {estaAberta && <div style={{ padding: '16px' }}>{children}</div>}
    </div>
  );
}

// ─── Status pill ──────────────────────────────────────────────────────────────
function StatusPill({ status }) {
  const ativo = status === 'A';
  const cor = ativo ? COR.verde : COR.amarelo;
  return (
    <span style={{
      display: 'inline-block', padding: '2px 10px',
      borderRadius: '20px', fontSize: '12px', fontWeight: '500',
      backgroundColor: ativo ? COR.verdeBg : COR.amlBg,
      color: cor,
      border: `1px solid ${cor}`,           // r109: borda na cor da fonte
    }}>{ativo ? 'Ativo' : 'Inativo'}</span>
  );
}

// r136: Campo atualizado (label 2px, espaçamento 0 — grids cuidam do espaço entre linhas)
function Campo({ label, children, obrigatorio, metade }) {
  return (
    <div style={{ marginBottom: '0', width: metade ? 'calc(50% - 5px)' : '100%' }}>
      <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: COR.muted, marginBottom: '2px' }}>
        {label}{obrigatorio && <span style={{ color: COR.vermelho }}> *</span>}
      </label>
      {children}
    </div>
  );
}

function Linha({ children }) {
  return <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>{children}</div>;
}

// ─── Form vazio ───────────────────────────────────────────────────────────────
const FORM_VAZIO = {
  razao_social: '', nome: '', insc_municipal: '', cnpj: '',
  logradouro: '', numero: '', complemento: '', bairro: '',
  municipio: '', uf: '', cep: '',
  pct_imposto: '', pct_custo: '',
  status: 'A', dados_bancarios: '',
};

// Converte null/undefined → string vazia
function sanitizar(obj) {
  return Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [k, v === null || v === undefined ? '' : v])
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
function EmpresasPage() {
  const [empresas, setEmpresas]       = useState([]);
  const [carregando, setCarregando]   = useState(true);
  const [busca, setBusca]             = useState('');
  const [ordenacao, setOrdenacao]     = useState({ campo: 'nome', dir: 'asc' });

  const [painel, setPainel]           = useState(null);
  const [selecionado, setSelecionado] = useState(null);
  // r136: abas removidas, substituídas por seções fixas/expansíveis
  const [form, setForm]               = useState(FORM_VAZIO);
  const [salvando, setSalvando]       = useState(false);
  const [erroPainel, setErroPainel]   = useState('');
  const [sucessoPainel, setSucessoPainel] = useState('');

  // r136: estado das seções expansíveis
  const [secoes, setSecoes] = useState({
    endereco:       true,   // começa aberta (campos essenciais)
    valoresBanco:   false,  // começa fechada
  });
  const toggleSec = (k) => setSecoes(s => ({ ...s, [k]: !s[k] }));

  // r136: modal de Valores sobreposto (não é mais aba/seção do form)
  const [modalValores, setModalValores] = useState(false);

  // ── Carregar ─────────────────────────────────────────────────────────────────
  const carregar = useCallback(async () => {
    try {
      setCarregando(true);
      const lista = await empresaService.listar();
      setEmpresas(lista);
    } catch {
      setEmpresas([]);
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => { carregar(); }, [carregar]);

  // ── Filtro e ordenação ───────────────────────────────────────────────────────
  const listaFiltrada = empresas
    .filter(e => {
      const q = busca.toLowerCase();
      return !q
        || e.nome.toLowerCase().includes(q)
        || e.razao_social.toLowerCase().includes(q)
        || (e.cnpj || '').includes(q);
    })
    .sort((a, b) => {
      const va = (a[ordenacao.campo] || '').toString().toLowerCase();
      const vb = (b[ordenacao.campo] || '').toString().toLowerCase();
      return ordenacao.dir === 'asc' ? va.localeCompare(vb) : vb.localeCompare(va);
    });

  const toggleOrdem = (campo) =>
    setOrdenacao(o => ({ campo, dir: o.campo === campo && o.dir === 'asc' ? 'desc' : 'asc' }));

  const setaCabecalho = (campo) => {
    if (ordenacao.campo !== campo) return ' ↕';
    return ordenacao.dir === 'asc' ? ' ↑' : ' ↓';
  };

  // ── Ações ─────────────────────────────────────────────────────────────────────
  const abrirNovo = () => {
    setForm(FORM_VAZIO);
    setSelecionado(null);
    setErroPainel(''); setSucessoPainel('');
    setPainel('novo');
  };

  const abrirVisualizar = (e) => {
    setSelecionado(e);
    setForm(sanitizar({ ...FORM_VAZIO, ...e }));
    setErroPainel(''); setSucessoPainel('');
    setPainel('visualizar');
  };

  const abrirEditar = (e) => {
    setSelecionado(e);
    setForm(sanitizar({ ...FORM_VAZIO, ...e }));
    setErroPainel(''); setSucessoPainel('');
    setPainel('editar');
  };

  const fecharPainel = () => { setPainel(null); setSelecionado(null); };

  // Recarrega lista e atualiza o form após mudança de valores (GridValores)
  const recarregarSelecionado = useCallback(async () => {
    if (!selecionado?.id) { await carregar(); return; }
    try {
      const lista = await empresaService.listar();
      setEmpresas(lista);
      const atualizado = lista.find(x => x.id === selecionado.id);
      if (atualizado) setForm(f => ({ ...f, ...sanitizar(atualizado) }));
    } catch { await carregar(); }
  }, [carregar, selecionado]);

  const handleCampo = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const alterarStatus = async (e) => {
    try {
      await empresaService.alterarStatus(e.id, e.status === 'A' ? 'I' : 'A');
      await carregar();
    } catch { alert('Erro ao alterar status.'); }
  };

  // Valida CNPJ (formato básico: 14 dígitos)
  const cnpjValido = (cnpj) => cnpj.replace(/\D/g, '').length === 14;

  // ── Salvar ────────────────────────────────────────────────────────────────────
  const salvar = async () => {
    setErroPainel('');
    if (!form.razao_social.trim())   return setErroPainel('Razão Social é obrigatória.');
    if (!form.nome.trim())           return setErroPainel('Nome Fantasia é obrigatório.');
    if (!form.cnpj.trim())           return setErroPainel('CNPJ é obrigatório.');
    if (!cnpjValido(form.cnpj))      return setErroPainel('CNPJ deve ter 14 dígitos.');
    if (!form.insc_municipal.trim()) return setErroPainel('Inscrição Municipal é obrigatória.');
    if (!form.logradouro.trim())     return setErroPainel('Logradouro é obrigatório.');
    if (!form.numero.trim())         return setErroPainel('Número é obrigatório.');
    if (!form.bairro.trim())         return setErroPainel('Bairro é obrigatório.');
    if (!form.municipio.trim())      return setErroPainel('Município é obrigatório.');
    if (!form.uf)                    return setErroPainel('UF é obrigatória.');
    if (!form.cep.trim())            return setErroPainel('CEP é obrigatório.');

    try {
      setSalvando(true);
      if (painel === 'novo') {
        await empresaService.incluir(form);
      } else {
        await empresaService.alterar(selecionado.id, form);
      }
      setSucessoPainel(painel === 'novo' ? 'Empresa incluída com sucesso!' : 'Empresa alterada com sucesso!');
      await carregar();
      setTimeout(fecharPainel, 1200);
    } catch (err) {
      setErroPainel(err.response?.data?.mensagem || 'Erro ao salvar. Verifique os dados.');
    } finally {
      setSalvando(false);
    }
  };

  const somenteLeitura = painel === 'visualizar';

  // ─── Render ───────────────────────────────────────────────────────────────────
  return (
    <div style={{ fontFamily: "'Manrope', sans-serif" }}>

      {/* r109: BrowseHeader padronizado no topo */}
      <BrowseHeader
        rotina="empresas"
        titulo="Empresas Internas"
        descricao="Cadastro das empresas (CNPJs) próprios que emitem nota e operam o sistema."
      />

      {/* ── BROWSE ── */}
      <div style={{
        flex: 1, backgroundColor: COR.branco,
        border: `1px solid ${COR.borda}`, borderRadius: '8px',
        overflow: 'hidden', minWidth: 0,
      }}>
        <div style={{
          padding: '14px 16px', borderBottom: `1px solid ${COR.borda}`,
          display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap',
        }}>
          <span style={{ fontSize: '13px', fontWeight: '500', color: COR.muted, flex: 1 }}>
            {listaFiltrada.length} registro{listaFiltrada.length !== 1 ? 's' : ''}
          </span>
          <input
            type="text" placeholder="Pesquisar..."
            value={busca} onChange={e => setBusca(e.target.value)}
            style={{ ...inputStyle, width: '320px' }}
          />
          <SePode rotina="empresas" acao="incluir"><BtnIcone icone="incluir" onClick={abrirNovo} title="Incluir nova empresa" cor={COR.azul} solido tamanho="grande" /></SePode>
        </div>

        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ backgroundColor: COR.azul }}>
                {/* r109: 1ª coluna fixa pro ícone SVG da rotina */}
                <th style={{ padding: '10px 14px', width: '36px' }}></th>
                {[
                  { label: 'Nome fantasia', campo: 'nome'         },
                  { label: 'Razão social',  campo: 'razao_social' },
                  { label: 'CNPJ',          campo: 'cnpj'         },
                  { label: 'Município',     campo: 'municipio'    },
                  { label: 'UF',            campo: 'uf'           },
                  { label: 'Status',        campo: 'status'       },
                  { label: 'Ações',         campo: null           },
                ].map(({ label, campo }) => (
                  <th key={label} onClick={() => campo && toggleOrdem(campo)} style={{
                    padding: '10px 14px', textAlign: 'left',
                    fontSize: '13px', fontWeight: '700', color: COR.branco,
                    whiteSpace: 'nowrap', cursor: campo ? 'pointer' : 'default', userSelect: 'none',
                  }}>
                    {label}{campo && setaCabecalho(campo)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {carregando ? (
                <tr><td colSpan="8" style={{ padding: '40px', textAlign: 'center', color: COR.muted }}>Carregando...</td></tr>
              ) : listaFiltrada.length === 0 ? (
                <tr><td colSpan="8" style={{ padding: '40px', textAlign: 'center', color: COR.muted }}>Nenhuma empresa encontrada.</td></tr>
              ) : listaFiltrada.map((e, i) => (
                <tr key={e.id} onClick={() => abrirVisualizar(e)} style={{
                  borderBottom: `1px solid ${COR.borda}`,
                  backgroundColor: selecionado?.id === e.id ? COR.azulBg : i % 2 === 0 ? COR.branco : '#fafafa',
                  cursor: 'pointer',
                }}>
                  {/* r109: ícone SVG #003399 da rotina (mesmo do menu lateral) */}
                  <td style={{ padding: '10px 0 10px 14px', verticalAlign: 'middle' }}>
                    {iconeDaRotina('empresas', { width: 20, height: 20, color: COR.azul })}
                  </td>
                  <td style={{ padding: '10px 14px', fontWeight: '500', color: COR.texto }}>{e.nome}</td>
                  <td style={{ padding: '10px 14px', color: COR.muted }}>{e.razao_social}</td>
                  <td style={{ padding: '10px 14px', color: COR.muted }}>{formatarCnpj(e.cnpj)}</td>
                  <td style={{ padding: '10px 14px', color: COR.muted }}>{e.municipio}</td>
                  <td style={{ padding: '10px 14px', color: COR.muted }}>{e.uf}</td>
                  <td style={{ padding: '10px 14px' }}><StatusPill status={e.status} /></td>
                  <td style={{ padding: '10px 14px' }}>
                    <div style={{ display: 'flex', gap: '4px' }} onClick={ev => ev.stopPropagation()}>
                      <SePode rotina="empresas" acao="alterar"><BtnIcone icone="alterar" onClick={() => abrirEditar(e)} title="Alterar" cor={COR.azul} /></SePode>
                      <SePode rotina="empresas" acao="alterar"><BtnIcone
                        icone={e.status === 'A' ? 'bloquear' : 'desbloquear'}
                        onClick={() => alterarStatus(e)}
                        title={e.status === 'A' ? 'Inativar' : 'Ativar'}
                        cor={e.status === 'A' ? COR.vermelho : COR.verde}
                      /></SePode>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ── MODAL ── */}
      <Modal
        aberto={!!painel}
        titulo={painel === 'novo' ? 'Nova Empresa' : painel === 'editar' ? 'Alterar Empresa' : 'Visualizar Empresa'}
        onFechar={fecharPainel}
        onSalvar={salvar}
        salvando={salvando}
        somenteLeitura={somenteLeitura}
        onEditar={() => setPainel('editar')}
        // r136: header rico padronizado (igual Colaborador)
        rotina="empresas"
        descricao="Cadastro das empresas (CNPJs) próprios que emitem nota e operam o sistema."
        botoesNoTopo={true}
        largura="95vw"
        // r136: botão Gerenciar Valores no header (igual Colaborador)
        botoesExtras={
          <button
            type="button"
            onClick={() => setModalValores(true)}
            disabled={!selecionado?.id}
            title={!selecionado?.id ? 'Salve a empresa antes de gerenciar valores' : 'Abrir tela de Valores'}
            style={{
              padding: '8px 18px',
              border: `1px solid ${!selecionado?.id ? 'rgba(255,255,255,0.25)' : 'rgba(255,255,255,0.5)'}`,
              borderRadius: '5px',
              backgroundColor: 'transparent',
              color: !selecionado?.id ? 'rgba(255,255,255,0.45)' : '#fff',
              fontSize: '13px', fontWeight: '500',
              cursor: !selecionado?.id ? 'not-allowed' : 'pointer',
              fontFamily: "'Manrope', sans-serif",
              display: 'inline-flex', alignItems: 'center', gap: '6px',
              whiteSpace: 'nowrap',
            }}
          >
            <SvgValores size={14} />
            Gerenciar Valores
          </button>
        }
      >
        <div>

          {erroPainel && (
            <div style={{ backgroundColor: COR.vermBg, border: `1px solid #ffcccc`, borderRadius: '5px', color: COR.vermelho, fontSize: '13px', padding: '10px 12px', marginBottom: '12px' }}>
              {erroPainel}
            </div>
          )}
          {sucessoPainel && (
            <div style={{ backgroundColor: COR.verdeBg, border: `1px solid #a8e6c1`, borderRadius: '5px', color: '#1d6a3a', fontSize: '13px', padding: '10px 12px', marginBottom: '12px' }}>
              {sucessoPainel}
            </div>
          )}


          {/* ═══ r136: Seções (modelo Colaborador) ═══ */}

          {/* ── SEÇÃO DADOS DA EMPRESA (fixa) ───────────────────────── */}
          <Secao icone={SvgEmpresa} titulo="Dados da Empresa" fixa>
            {/* Razão Social | Nome Fantasia */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <Campo label="Razão Social" obrigatorio>
                <input name="razao_social" value={form.razao_social} onChange={handleCampo}
                  disabled={somenteLeitura} style={inputStyle} placeholder="Razão Social" maxLength={100} />
              </Campo>
              <Campo label="Nome Fantasia" obrigatorio>
                <input name="nome" value={form.nome} onChange={handleCampo}
                  disabled={somenteLeitura} style={inputStyle} placeholder="Nome Fantasia" maxLength={100} />
              </Campo>
            </div>

            {/* CNPJ | Insc. Municipal | Status */}
            <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr 0.8fr', gap: '10px', marginTop: '20px' }}>
              <Campo label="CNPJ" obrigatorio>
                <input
                  name="cnpj"
                  value={mascararCnpj(form.cnpj)}
                  onChange={e => setForm(f => ({ ...f, cnpj: e.target.value.replace(/\D/g, '') }))}
                  disabled={somenteLeitura} style={inputStyle}
                  placeholder="00.000.000/0000-00" maxLength={18}
                />
              </Campo>
              <Campo label="Insc. Municipal" obrigatorio>
                <input name="insc_municipal" value={form.insc_municipal} onChange={handleCampo}
                  disabled={somenteLeitura} style={inputStyle} placeholder="Inscrição Municipal" maxLength={20} />
              </Campo>
              <Campo label="Status" obrigatorio>
                <select name="status" value={form.status} onChange={handleCampo} disabled={somenteLeitura}
                  style={somenteLeitura ? inputStyle : selectStyle}>
                  <option value="A">Ativo</option>
                  <option value="I">Inativo</option>
                </select>
              </Campo>
            </div>
          </Secao>

          {/* ── SEÇÃO ENDEREÇO (expansível, começa aberta) ──────────── */}
          <Secao icone={SvgEndereco} titulo="Endereço"
                 aberta={secoes.endereco} onToggle={() => toggleSec('endereco')}>
            {/* Logradouro | Número | Complemento */}
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 0.6fr 1fr', gap: '10px' }}>
              <Campo label="Logradouro" obrigatorio>
                <input name="logradouro" value={form.logradouro} onChange={handleCampo}
                  disabled={somenteLeitura} style={inputStyle} placeholder="Rua, Av., Travessa..." maxLength={80} />
              </Campo>
              <Campo label="Número" obrigatorio>
                <input name="numero" value={form.numero} onChange={handleCampo}
                  disabled={somenteLeitura} style={inputStyle} placeholder="Nº" maxLength={8} />
              </Campo>
              <Campo label="Complemento">
                <input name="complemento" value={form.complemento} onChange={handleCampo}
                  disabled={somenteLeitura} style={inputStyle} placeholder="Apto, Sala..." maxLength={50} />
              </Campo>
            </div>

            {/* Bairro | Município | UF | CEP */}
            <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1.2fr 0.5fr 1fr', gap: '10px', marginTop: '20px' }}>
              <Campo label="Bairro" obrigatorio>
                <input name="bairro" value={form.bairro} onChange={handleCampo}
                  disabled={somenteLeitura} style={inputStyle} placeholder="Bairro" maxLength={30} />
              </Campo>
              <Campo label="Município" obrigatorio>
                <input name="municipio" value={form.municipio} onChange={handleCampo}
                  disabled={somenteLeitura} style={inputStyle} placeholder="Município" maxLength={50} />
              </Campo>
              <Campo label="UF" obrigatorio>
                <select name="uf" value={form.uf} onChange={handleCampo} disabled={somenteLeitura}
                  style={somenteLeitura ? inputStyle : selectStyle}>
                  <option value="">UF</option>
                  {UFS.map(uf => <option key={uf} value={uf}>{uf}</option>)}
                </select>
              </Campo>
              <Campo label="CEP" obrigatorio>
                <input
                  name="cep"
                  value={mascararCep(form.cep)}
                  onChange={e => setForm(f => ({ ...f, cep: limparCep(e.target.value) }))}
                  disabled={somenteLeitura} style={inputStyle}
                  placeholder="00000-000" maxLength={9}
                />
              </Campo>
            </div>
          </Secao>

          {/* ── SEÇÃO VALORES / DADOS BANCÁRIOS (expansível, começa fechada) ── */}
          <Secao icone={SvgFinanceiro} titulo="Valores / Dados Bancários"
                 aberta={secoes.valoresBanco} onToggle={() => toggleSec('valoresBanco')}>
            {/* % Imposto | % Custo Operacional (read-only — gerenciados pelo modal de Valores) */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <Campo label="% Imposto">
                <input
                  value={form.pct_imposto ? parseFloat(form.pct_imposto).toFixed(2) + '%' : '—'}
                  disabled
                  style={{ ...inputStyle, backgroundColor: '#fafafa', color: COR.muted }}
                />
              </Campo>
              <Campo label="% Custo Operacional">
                <input
                  value={form.pct_custo ? parseFloat(form.pct_custo).toFixed(2) + '%' : '—'}
                  disabled
                  style={{ ...inputStyle, backgroundColor: '#fafafa', color: COR.muted }}
                />
              </Campo>
            </div>
            <div style={{ fontSize: '11px', color: COR.muted, marginTop: '6px', marginBottom: '20px' }}>
              Valores gerenciados pelo botão <b>Gerenciar Valores</b> no topo da tela.
            </div>

            {/* Dados Bancários (textarea) */}
            <Campo label="Dados Bancários">
              <textarea
                name="dados_bancarios"
                value={form.dados_bancarios}
                onChange={handleCampo}
                disabled={somenteLeitura}
                style={{ ...textareaStyle, minHeight: '120px' }}
                placeholder="Banco, agência, conta, PIX, nome do titular..."
              />
            </Campo>
          </Secao>

        </div>

        {/* r136: Modal de Valores sobreposto (renderiza por cima do modal principal) */}
        {modalValores && (
          <Modal
            aberto={modalValores}
            titulo={`Valores — ${form.nome || form.razao_social || 'Empresa'}`}
            onFechar={() => setModalValores(false)}
            onSalvar={() => setModalValores(false)}
            salvando={false}
            somenteLeitura={somenteLeitura}
            rotina="empresas"
            descricao="Gerenciamento de % Imposto e % Custo Operacional históricos da empresa."
            botoesNoTopo={true}
            largura="90vw"
          >
            <GridValores
              vinculo="E"
              idVinculo={selecionado?.id}
              nome={form.nome}
              somenteLeitura={somenteLeitura}
              onAtualizado={recarregarSelecionado}
            />
          </Modal>
        )}
      </Modal>
    </div>
  );
}

export default EmpresasPage;
